import { Eye, EyeOff, Lock } from 'lucide-react';
import { forwardRef, useState } from 'react';

import { Input, type InputProps } from '@/shared/ui/shadcn/input';

export type PasswordInputProps = Omit<InputProps, 'type' | 'leadingIcon' | 'trailingIcon'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [show, setShow] = useState(false);

  const toggleLabel = show ? 'Ocultar contraseña' : 'Mostrar contraseña';
  const ToggleIcon = show ? EyeOff : Eye;

  return (
    <Input
      {...props}
      ref={ref}
      type={show ? 'text' : 'password'}
      leadingIcon={<Lock aria-hidden="true" />}
      trailingIcon={
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={toggleLabel}
          aria-pressed={show}
          className="pointer-events-auto inline-flex items-center justify-center rounded-sm text-[var(--input-icon-color)] outline-none transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <ToggleIcon aria-hidden="true" />
        </button>
      }
    />
  );
});
PasswordInput.displayName = 'PasswordInput';
